import api from "./api";

export interface VarianteSeccion {
  id: string;
  slug: string;
  nombre: string;
  descripcion: string;
  imageUrl: string;
  s3Key?: string;
  active: boolean;
}

export interface SeccionAgenda {
  id: string;
  nombre: string;
  descripcion: string;
  categoria: "productivity" | "wellness" | "creativity" | "finance" | "other";
  paginas: number;
  precio: number;
  imageUrl: string;
  s3Key?: string;
  icon: string;
  active: boolean;
  orden: number;
  variantes: VarianteSeccion[];
  createdAt?: string;
  updatedAt?: string;
}

interface SeccionesResponse {
  success: boolean;
  secciones: SeccionAgenda[];
  count: number;
}

interface SeccionResponse {
  success: boolean;
  seccion: SeccionAgenda;
  message: string;
}

export const seccionesAgendaService = {
  /** Obtener secciones activas para el builder (uso público) */
  async getSecciones(): Promise<SeccionAgenda[]> {
    const response = await api.get<SeccionesResponse>("/secciones-agenda");
    return response.data.secciones;
  },

  /** ADMIN: Obtener todas las secciones (activas e inactivas) */
  async getSeccionesAdmin(): Promise<SeccionAgenda[]> {
    const response = await api.get<SeccionesResponse>("/secciones-agenda/admin");
    return response.data.secciones;
  },

  /** ADMIN: Crear nueva sección (con imagen opcional) */
  async crearSeccion(formData: FormData): Promise<SeccionAgenda> {
    const response = await api.post<SeccionResponse>("/secciones-agenda", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.seccion;
  },

  /** ADMIN: Actualizar sección (con imagen opcional) */
  async actualizarSeccion(id: string, formData: FormData): Promise<SeccionAgenda> {
    const response = await api.put<SeccionResponse>(`/secciones-agenda/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.seccion;
  },

  /** ADMIN: Eliminar sección */
  async eliminarSeccion(id: string): Promise<void> {
    await api.delete(`/secciones-agenda/${id}`);
  },

  /** ADMIN: Reordenar secciones */
  async reordenar(items: { id: string; orden: number }[]): Promise<void> {
    await api.put("/secciones-agenda/reorder", { items });
  },

  // --- Variantes ---

  /** ADMIN: Agregar variante a una sección */
  async agregarVariante(seccionId: string, formData: FormData): Promise<SeccionAgenda> {
    const response = await api.post<SeccionResponse>(
      `/secciones-agenda/${seccionId}/variantes`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data.seccion;
  },

  /** ADMIN: Actualizar variante */
  async actualizarVariante(
    seccionId: string,
    varianteId: string,
    formData: FormData
  ): Promise<SeccionAgenda> {
    const response = await api.put<SeccionResponse>(
      `/secciones-agenda/${seccionId}/variantes/${varianteId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data.seccion;
  },

  /** ADMIN: Eliminar variante */
  async eliminarVariante(seccionId: string, varianteId: string): Promise<void> {
    await api.delete(`/secciones-agenda/${seccionId}/variantes/${varianteId}`);
  },
};

export default seccionesAgendaService;
